// @ts-nocheck
export const MODEL_NAME = 'advertising';
export const ADS_TABLE_ID = 44;
export const AD_TYPES_TABLE = 45;
